import React from 'react'
import MaskedInputWrap from '.././maskedInputWrap.jsx'

const saveButton = props => {
    let {
        tfa_code,
        profileData,
        profileDataParams,
        structureOfPostDataRequest,
    } = props

    let userDataChanged = {}
    let personalDataChanged = {}

    for (let item in profileData) {
        let key = profileData[item]['key']
        if (
            profileData[item]['value'] !== profileDataParams[key] &&
            profileData[item]['key'] !== 'firstname' &&
            profileData[item]['key'] !== 'lastname'
        ) {
            personalDataChanged[key] = profileDataParams[key]
        } else if (
            profileData[item]['value'] !== profileDataParams[key] &&
            (profileData[item]['key'] === 'firstname' ||
                profileData[item]['key'] === 'lastname')
        ) {
            userDataChanged[key] = profileDataParams[key]
        }
    }

    let userDataChangedLength = Object.keys(userDataChanged).length
    let personalDataChangedLength = Object.keys(personalDataChanged).length

    if (tfa_code.length === 6) {
        if (userDataChangedLength !== 0 && personalDataChangedLength !== 0) {
            structureOfPostDataRequest(personalDataChanged, userDataChanged)
        } else if (
            userDataChangedLength !== 0 &&
            personalDataChangedLength === 0
        ) {
            structureOfPostDataRequest({}, userDataChanged)
        } else if (personalDataChangedLength !== 0) {
            structureOfPostDataRequest(personalDataChanged, {})
        }
    }
}

export default saveButton
